import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../css/supply.css';

function Home() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const underlineRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50); // Delay before animation starts
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {/* Section 1: Mission & Vision */}
            <div className="container-fluid about-bg8 d-flex align-items-end mb-5" style={{ padding: 0, minHeight: '70vh', top: '-122px' }}>
                <div className="container-fluid align-items-center justify-content-center about-content">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="d-flex flex-column flex-md-row align-items-start ms-5">
                                <div className="me-md-5">
                                    <h1 className="about-title">Supply Chain Services</h1>
                                    <h2 className="about-subtitle">Petrochoice Integrated Services</h2>
                                    <div className="about-underline" ref={underlineRef}></div>
                                </div>
                                {/* <div>
                                    <p className="about-desc ms-5 align-items-center" style={{ fontSize: 19 }}>
                                        At Petrochoice, we provide a comprehensive team of specialized drilling personnel and performance specialists, including rig crew members, who are crucial to optimizing drilling operations, minimizing lost time, and reducing costs. Our diverse team comprises experts in various drilling aspects, ensuring that we offer comprehensive support and expertise throughout the drilling process.
                                    </p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Section 2: Supply Content */}
            <section className="py-5 bg-white">
                <div className="container">
                    {/* Introduction Card */}
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-10">
                            <div className="card border-0 shadow-lg intro-card" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                                <div className="card-body p-5" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                                    <div className="text-center mb-4">
                                        <div className="bg-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                                            <i className="fas fa-truck text-white" style={{ fontSize: '2rem' }}></i>
                                        </div>
                                        <h2 className="fw-bold mb-3" style={{ color: '#0c61c0', fontFamily: 'Poppins, sans-serif' }}>
                                            Supply Chain Excellence
                                        </h2>
                                    </div>
                                    <p className="text-center mb-0" style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#495057' }}>
                                        In the intricate realm of the oil and gas industry, efficient supply chain management stands as an indispensable pillar supporting seamless operations. Our comprehensive suite of supply chain services covers every facet, from meticulous procurement processes to the intricacies of logistics, inventory management, and rigorous vendor qualification.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Supply Categories Grid */}
                    <div className="row g-4">
                        {[
                            {
                                icon: "fas fa-tools",
                                title: "Drilling Tools",
                                desc: "Comprehensive selection: drill bits, collars, jars, stabilizers, reamers, and more — essential for efficiency and effectiveness of drilling operations.",
                                color: "#0c61c0",
                                bgImage: "url('/assets/drilling_tools.jpg')"
                            },
                            {
                                icon: "fas fa-cogs",
                                title: "Rig Spare Parts",
                                desc: "Vast inventory ensuring swift access to critical components: drawworks, mud pumps, top drives, rotary tables, and more.",
                                color: "#28a745",
                                bgImage: "url('/assets/rig_equipment.jpg')"
                            },
                            {
                                icon: "fas fa-layer-group",
                                title: "Centralizers & Casing Accessories",
                                desc: "Solutions that support proper wellbore placement, cementing operations, and casing integrity.",
                                color: "#fd7e14",
                                bgImage: "url('/assets/Casing-ACCESSORIES.jpg')"
                            },
                            {
                                icon: "fas fa-filter",
                                title: "Solid Control Equipment",
                                desc: "High‑performance equipment: shale shakers, mud cleaners, centrifuges, degassers — maintaining drilling fluid properties and eliminating cuttings.",
                                color: "#dc3545",
                                bgImage: "url('/assets/SOLID CONTROL EQUIPMENT.jpg')"
                            },
                            {
                                icon: "fas fa-pipe",
                                title: "Seamless and Welded Pipes",
                                desc: "Various sizes, grades, and specs to meet diverse oil and gas project needs.",
                                color: "#6f42c1",
                                bgImage: "url('/assets/PIPES.jpeg')"
                            },
                            {
                                icon: "fas fa-valve",
                                title: "Valves, Flanges, and Fittings",
                                desc: "Wide range of essentials for pipeline and facility construction: gate, ball, and check valves; flanges, elbows, tees.",
                                color: "#20c997",
                                bgImage: "url('/assets/VALVES, FLANG.jpg')"
                            },
                            {
                                icon: "fas fa-piggy-bank",
                                title: "Pipeline Pigs",
                                desc: "Cleaning, inspection, and maintenance pigs — including cleaning, gauging, and intelligent pigs.",
                                color: "#ffc107",
                                bgImage: "url('/assets/PIGS.jpg')"
                            },
                            {
                                icon: "fas fa-oil-can",
                                title: "Valve Lubricants and Sealants",
                                desc: "High‑quality lubricants and sealants to ensure smooth, leak‑free valve performance.",
                                color: "#17a2b8",
                                bgImage: "url('/assets/LUBRICANTA ND SEALANT.png')"
                            },
                            {
                                icon: "fas fa-flask",
                                title: "Upstream and Downstream Chemicals",
                                desc: "Extensive inventory supporting upstream and downstream operations: drilling fluids, production chemicals, corrosion inhibitors, and more.",
                                color: "#6c757d",
                                bgImage: "url('/assets/CHEMICALS.avif')"
                            },
                            {
                                icon: "fas fa-tachometer-alt",
                                title: "Liquid Level Indicators and Sensors",
                                desc: "Precise tank level monitoring and accurate measurements for diverse applications.",
                                color: "#e83e8c",
                                bgImage: "url('/assets/LIQUID LEVEL AND SENSOS.jpg')"
                            },
                            {
                                icon: "fas fa-chart-line",
                                title: "Measurement Instruments and Automation",
                                desc: "Flow meters, pressure transmitters, level sensors, and control services for precise monitoring and control.",
                                color: "#fd7e14",
                                bgImage: "url('/assets/INSTRUMENTS.jpg')"
                            },
                            {
                                icon: "fas fa-bolt",
                                title: "Mechanical and Electrical Equipment",
                                desc: "Motors, generators, pumps, compressors, turbines, and related equipment for facilities.",
                                color: "#28a745",
                                bgImage: "url('/assets/Mechanical and Electrical Services-small-1.jpg')"
                            },
                            {
                                icon: "fas fa-compress-arrows-alt",
                                title: "Pumps and Compressors",
                                desc: "Centrifugal, reciprocating, and rotary screw compressors — plus more for oil and gas operations.",
                                color: "#dc3545",
                                bgImage: "url('/assets/PUMP AND COMPRESSORS.jpg')"
                            },
                            {
                                icon: "fas fa-puzzle-piece",
                                title: "Spare Parts",
                                desc: "Extensive inventory to ensure on‑time availability of critical components for maintenance and repairs.",
                                color: "#6f42c1",
                                bgImage: "url('/assets/SPARE APRTS.jpg')"
                            },
                            {
                                icon: "fas fa-fire",
                                title: "Refractories",
                                desc: "Heat‑resistant refractories designed for high‑temperature applications in furnaces, boilers, and kilns.",
                                color: "#fd7e14",
                                bgImage: "url('/assets/REFRACTORS.jpg')"
                            },
                            {
                                icon: "fas fa-hard-hat",
                                title: "Personal Protective Equipment (PPE)",
                                desc: "Safety helmets, gloves, goggles, protective clothing, and respiratory protection for industry professionals.",
                                color: "#20c997",
                                bgImage: "url('/assets/ppe.jpeg')"
                            },
                            {
                                icon: "fas fa-hard-hat",
                                title: "Explosion proof equipment",
                                desc: "Explosion proof equipment for hazardous environments.",
                                color: "#20c997",
                                bgImage: "url('/assets/explosion-proof-electrical-equipment-14.jpg')"
                            }
                        ].map((item, index) => (
                            <div key={index} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="card h-100 border-0 shadow-sm supply-card" style={{
                                    borderRadius: '12px',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    backgroundImage: item.bgImage,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <div className="card-body p-4" style={{ position: 'relative', zIndex: 2 }}>
                                        <div className="d-flex align-items-start mb-3">
                                            
                                            <div className="flex-grow-1">
                                                <h5 className="fw-bold mb-2" style={{
                                                    fontSize: '1.1rem',
                                                    color: '#1e293b',
                                                    fontFamily: 'Poppins, sans-serif'
                                                }}>
                                                    {item.title}
                                                </h5>
                                            </div>
                                        </div>
                                        <p className="mb-0" style={{
                                            fontSize: '0.95rem',
                                            lineHeight: '1.6',
                                            color: 'black',
                                            textAlign: 'justify'
                                        }}>
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Commitment Section */}
                    <div className="row justify-content-center mt-5">
                        <div className="col-lg-10">
                            <div className="card border-0 shadow-lg commitment-card" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                                <div className="card-body p-5 text-center" style={{ background: 'linear-gradient(135deg, #0c61c0 0%, #084b9a 100%)' }}>
                                    <div className="bg-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                                        <i className="fas fa-handshake text-primary" style={{ fontSize: '2rem' }}></i>
                                    </div>
                                    <h3 className="text-white fw-bold mb-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                                        Our Commitment
                                    </h3>
                                    <p className="text-white mb-0" style={{ fontSize: '1.1rem', lineHeight: '1.7', opacity: '0.9' }}>
                                        Our unwavering commitment to quality, reliability, and timely delivery underscores our dedication to meeting the distinct requirements of our clients. The Petrochoice supply chain team is devoted to sourcing and delivering the highest‑quality supplies, ensuring industry professionals' success.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Home;
